import Vue from 'vue'

import LoadingAction from '@c/LoadingAction'
import ContentHeader from '@c/ContentHeader'
import LoginForm from '@c/LoginForm'

Vue.component('LoadingAction', LoadingAction)
Vue.component('ContentHeader', ContentHeader)
Vue.component('LoginForm', LoginForm)
